/* eslint-disable import/no-anonymous-default-export */
export default {
  "nav.home": "홈",
  "nav.about": "회사 소개",
  "nav.services": "서비스",
  "nav.creators": "크리에이터",
  "nav.contact": "문의",
  "lang.en": "EN",
  "lang.ko": "KO",
  "lang.zh": "中文",

  "hero.tagline": "샤오홍슈 마케팅 & 라이브 커머스 전문 에이전시",
  "hero.title_line1": "샤오홍슈에서,",
  "hero.title_line2": "진짜 사랑받는 브랜드가 됩니다",
  "hero.description": "Dragonfruit는 한국 브랜드의 샤오홍슈 진출을 전문으로 합니다. 콘텐츠 기획, K-크리에이터 라이브 커머스, 스토어 운영, 중국 시장 전략까지. 중국 소비자가 진심으로 공감하는 브랜드가 되도록, 처음부터 끝까지 함께합니다.",
  "hero.cta_primary": "무료 상담 신청",
  "hero.cta_secondary": "서비스 둘러보기",

  "stats.countries": "500+",
  "stats.countries_label": "샤오홍슈 라이브 진행",
  "stats.partners": "80+",
  "stats.partners_label": "중국 진출 브랜드",
  "stats.support": "1,500만+",
  "stats.support_label": "누적 시청자",
  "stats.global_hub": "98%",
  "stats.global_hub_label": "고객 재계약률",

  "services.title": "샤오홍슈에서 통하는 브랜드, Dragonfruit가 만듭니다",
  "services.content_production": "샤오홍슈 콘텐츠 마케팅",
  "services.content_production_desc": "중국 소비자가 스크롤을 멈추고 저장하는 콘텐츠를 만듭니다. 알고리즘 분석과 트렌드 예측으로 노출을 끌어올리고, 브랜드가 샤오홍슈에서 자연스럽게 녹아드는 이야기를 기획합니다.",
  "services.live_operations": "샤오홍슈 라이브 커머스",
  "services.live_operations_desc": "K-크리에이터와 함께하는 라이브는 단순한 판매가 아닙니다. 중국 소비자가 신뢰하는 진짜 리뷰와 현장감 있는 연출로, 한 번의 라이브가 브랜드 팬을 만드는 순간이 되도록 기획합니다.",
  "services.commerce_support": "샤오홍슈 스토어 운영",
  "services.commerce_support_desc": "스토어 개설부터 상품 등록, 주문 처리, 고객 응대, 데이터 리포트까지. 마치 자사 스토어처럼 세심하게 관리하여 안정적인 매출 채널이 되도록 합니다.",
  "services.shop_management": "K-크리에이터 매칭",
  "services.shop_management_desc": "숫자가 아닌 진짜 매력을 봅니다. 브랜드 가치관과 잘 맞는 K-크리에이터를 찾아 장기 파트너십으로 연결하고, 성과는 투명하게 공유합니다.",

  "about.heading": "회사 소개",
  "about.company_name": "Dragonfruit",
  "about.section_title": "왜 Dragonfruit인가",
  "about.company_desc": "Dragonfruit는 샤오홍슈를 모르는 한국 브랜드와, 한국을 모르는 중국 소비자를 잇습니다. 단순한 대행이 아닙니다. 브랜드의 샤오홍슈 성장을 함께 설계하고 책임지는 동료입니다.",
  "about.company_desc2": "샤오홍슈는 3억 명 이상의 중국 소비자가 제품을 검색하고, 리뷰를 읽고, 구매를 결정하는 거대한 라이프스타일 플랫폼입니다. 하지만 중국 시장은 문화와 알고리즘이 다릅니다. Dragonfruit는 한국 브랜드가 이 시장에서 주목받고, 오래 사랑받을 수 있도록 콘텐츠·라이브·스토어·크리에이터 매칭까지 전 과정을 함께합니다.",
  "about.vision_title": "비전",
  "about.vision_text": "한국의 감성과 중국의 트렌드를 연결하는 가장 자연스러운 다리가 되겠습니다.",
  "about.vision_text2": "단순히 제품을 파는 것이 아닙니다. 중국 소비자가 한국 브랜드를 진심으로 좋아하고, 찾고, 추천하는 관계를 만드는 것이 우리의 목표입니다. 그래서 Dragonfruit라는 이름을 가졌습니다. 용과처럼 독특하고 기억에 남는 브랜드가 되도록 돕겠습니다.",
  "about.mission_title": "미션",
  "about.mission_text": "진짜 이야기를 전합니다. 숫자를 속이지 않고, 콘텐츠를 대충 만들지 않고, 단기 매출만 좇지 않습니다.",
  "about.mission_text2": "샤오홍슈에서 오래 사랑받는 브랜드를 만드는 것이 우리의 일입니다. 중국 소비자의 니즈를 정확히 읽고, K-크리에이터의 진짜 매력과 결합해 실질적인 성과를 창출하되, 그 과정에서 브랜드의 정체성을 지키는 것. 그것이 Dragonfruit의 약속입니다.",
  "about.values_title": "핵심 가치",
  "about.values_subtitle": "Dragonfruit가 일하는 다섯 가지 원칙. 이 원칙은 고객에게도, 크리에이터에게도, 우리 팀에게도 똑같이 적용됩니다.",
  "about.values.growth": "중국 소비자를 먼저 이해합니다",
  "about.values.growth_desc": "데이터와 알고리즘보다 먼저, 중국 소비자가 무엇을 원하고 어떤 말투로 공감하는지 깊이 있게 파악합니다. 그것이 모든 전략의 시작입니다.",
  "about.values.creativity": "K-감성을 제대로 전달합니다",
  "about.values.creativity_desc": "한국 브랜드만이 가진 독특한 감성과 스토리를, 중국 소비자가 자연스럽게 받아들일 수 있는 방식으로 번역하고 재창조합니다.",
  "about.values.mindset": "투명하게, 함께합니다",
  "about.values.mindset_desc": "라이브 매출, 캠페인 데이터, 스토어 성과를 숨기지 않고 공유합니다. 신뢰를 기반으로 한 장기 파트너십을 만드는 것이 우리의 자랑입니다.",
  "about.values.integrity": "콘텐츠를 장난치지 않습니다",
  "about.values.integrity_desc": "대충 찍어 올리는 콘텐츠는 만들지 않습니다. 중국 소비자가 저장하고, 댓글 달고, 친구에게 공유할 가치 있는 콘텐츠만을 생산합니다.",
  "about.values.impact": "단기 매출보다 브랜딩",
  "about.values.impact_desc": "한 번의 라이브 매출에 만족하지 않습니다. 브랜드가 샤오홍슈에서 지속적으로 성장할 수 있는 자산을 쌓는 것이 진짜 성과라고 믿습니다.",

  "contact.heading": "문의하기",
  "contact.subtitle": "샤오홍슈, 함께 시작해볼까요? 브랜드의 현재 상황과 목표를 들려주시면, 딱 맞는 샤오홍슈 전략을 함께 설계하겠습니다. 상담은 언제나 무료입니다.",
  "contact.full_name": "이름",
  "contact.full_name_placeholder": "이름을 입력하세요",
  "contact.email": "이메일",
  "contact.email_placeholder": "이메일을 입력하세요",
  "contact.phone": "전화번호",
  "contact.phone_placeholder": "전화번호를 입력하세요",
  "contact.datetime": "상담 일정",
  "contact.service": "어떤 서비스가 궁금하신가요?",
  "contact.service_placeholder": "문의 유형을 선택하세요",
  "contact.service_content": "샤오홍슈 콘텐츠 마케팅",
  "contact.service_live": "샤오홍슈 라이브 커머스",
  "contact.service_commerce": "샤오홍슈 스토어 운영",
  "contact.service_creator": "K-크리에이터 매칭",
  "contact.service_other": "기타",
  "contact.send": "무료 상담 신청",
  "contact.success": "문의가 접수되었습니다! 24시간 내에 Dragonfruit 팀이 직접 연락드리겠습니다.",
  "contact.address": "서울특별시 서초구 남부순환로339길 60, HJ타워 402-22, 4층",
  "contact.postal": "06722, 대한민국",
  "contact.website": "https://d-fruit.net/",
  "contact.address_label": "주소",
  "contact.opening_hours": "운영 시간",
  "contact.mon": "월",
  "contact.tue": "화",
  "contact.wed": "수",
  "contact.thu": "목",
  "contact.fri": "금",
  "contact.hours": "오전 10시 - 오후 7시",

  "footer.copyright": "© 2025 Dragonfruit. All Rights Reserved.",
  "footer.privacy": "개인정보처리방침",
  "footer.terms": "이용약관",

  "creators.heading": "소속 크리에이터",
  "creators.subtitle": "Dragonfruit와 함께 샤오홍슈에서 활약하는 K-크리에이터들입니다. 이들은 단순한 인플루언서가 아닙니다. 각자의 분야에서 진짜 전문성을 가진 파트너들이며, 중국 소비자와 깊은 신뢰를 쌓고 있습니다.",
  "creators.filter_all": "전체",
  "creators.filter_beauty": "뷰티",
  "creators.filter_fashion": "패션",
  "creators.filter_food": "푸드",
  "creators.filter_lifestyle": "라이프스타일",
  "creators.filter_travel": "여행",
  "creators.followers": "팔로워",
  "creators.instagram": "인스타그램",
  "creators.tiktok": "틱톡",
  "creators.xiaohongshu": "샤오홍슈",
  "creators.view_profile": "프로필 보기",
  "creators.join_title": "Dragonfruit와 함께할 크리에이터를 찾습니다",
  "creators.join_tagline": "크리에이터 지원",
  "creators.join_desc": "당신의 콘텐츠에 진심이 담겨 있나요? 중국 소비자와 소통하고 싶은 열정이 있다면, Dragonfruit가 그 길을 함께합니다. 우리는 단순히 방송 일정을 잡아주는 회사가 아닙니다. 크리에이터의 장기적인 성장을 함께 설계하는 동료가 되겠습니다.",
  "creators.join_cta": "크리에이터 지원하기",
  "creators.join_name": "이름",
  "creators.join_name_placeholder": "이름을 입력하세요",
  "creators.join_email": "이메일",
  "creators.join_email_placeholder": "이메일을 입력하세요",
  "creators.join_phone": "전화번호",
  "creators.join_phone_placeholder": "전화번호를 입력하세요",
  "creators.join_category": "주요 콘텐츠 분야",
  "creators.join_category_placeholder": "분야를 선택하세요",
  "creators.join_message": "지원 동기 및 자기소개",
  "creators.join_message_placeholder": "자신의 콘텐츠 스타일과 샤오홍슈에서 보여주고 싶은 모습, Dragonfruit와 함께하고 싶은 이유를 자유롭게 적어주세요 (최대 500자)",
  "creators.join_send": "지원서 제출",
  "creators.join_success": "지원서가 접수되었습니다! 검토 후 개별 연락드리겠습니다.",
  "creators.no_results": "해당 분야의 크리에이터가 아직 없습니다.",

  "nav.brands": "브랜드",

  "brands.hero.tagline": "샤오홍슈를 중심으로 한 글로벌 브랜드 성장 파트너",
  "brands.hero.title_line1": "한국 브랜드의 중국 시장 진출,",
  "brands.hero.title_line2": "Dragonfruit가 함께합니다",
  "brands.hero.description": "샤오홍슈에서 시작해 TikTok Shop, Shopify, Douyin까지. 중국 소비자가 진짜 사랑하는 브랜드가 되도록 처음부터 끝까지 함께합니다.",
  "brands.hero.cta": "무료 상담 신청",

  "brands.services.title": "브랜드를 위한 Dragonfruit의 서비스",
  "brands.services.subtitle": "샤오홍슈는 메인 무대이며, 글로벌 플랫폼으로 확장하는 것도 자연스럽습니다",
  "brands.services.xiaohongshu.title": "샤오홍슈 원스톱 솔루션",
  "brands.services.xiaohongshu.desc": "콘텐츠 마케팅, 라이브 커머스, 스토어 운영, K-크리에이터 매칭까지. 샤오홍슈 진출의 전 과정을 하나의 파트너가 책임집니다.",
  "brands.services.global.title": "글로벌 플랫폼 확장",
  "brands.services.global.desc": "TikTok Shop, Shopify, Douyin(抖音) 등 중국 및 글로벌 플랫폼으로 브랜드의 영역을 넓힙니다. 플랫폼별 최적화된 전략으로 매출 채널을 다변화합니다.",
  "brands.services.analytics.title": "데이터 기반 성과 관리",
  "brands.services.analytics.desc": "콘텐츠 조회수, 라이브 매출, 스토어 전환율 등 실시간 데이터를 투명하게 공유합니다. 성과 중심의 체계적인 운영을 보장합니다.",

  "brands.locations.title": "글로벌 네트워크",
  "brands.locations.heading": "한국을 본부로, 전 세계 주요 시장에서 브랜드 성장을 지원합니다",
  "brands.locations.subtitle": "한국을 본부로, 중국·일본·미국·캐나다·중동·유럽까지. 각 지역에 맞는 현지화 전략을 제공합니다.",
  "brands.locations.stat_brands": "브랜드",
  "brands.locations.stat_creators": "크리에이터",
  "brands.locations.stat_campaigns": "캠페인",
  "brands.locations.korea": "한국 (본부)",
  "brands.locations.japan": "일본",
  "brands.locations.china": "중국",
  "brands.locations.usa": "미국",
  "brands.locations.canada": "캐나다",
  "brands.locations.middle_east": "중동",
  "brands.locations.europe": "유럽",
  "brands.locations.korea_desc": "샤오홍슈 콘텐츠 기획, K-크리에이터 매칭, 라이브 커머스 전략 수립",
  "brands.locations.japan_desc": "라이브 커머스 운영 지원, 현지화 콘텐츠 제작, 일본 플랫폼 확장 컨설팅",
  "brands.locations.china_desc": "샤오홍슈 스토어 운영, Douyin 라이브 커머스, 현지 파트너 네트워크 활용",
  "brands.locations.usa_desc": "TikTok Shop 입점 지원, Shopify 글로벌 스토어 운영, 현지 인플루언서 콜라보",
  "brands.locations.canada_desc": "북미 시장 맞춤 콘텐츠 전략, 글로벌 이커머스 채널 확장, 다문화 마케팅",
  "brands.locations.middle_east_desc": "중동 뷰티&패션 트렌드 분석, 현지화 콘텐츠 기획, 지역별 플랫폼 대응",
  "brands.locations.europe_desc": "유럽 시장 진출 전략, 글로벌 브랜드 로컬라이제이션, 크로스보더 커머스 지원",

  "brands.process.title": "브랜드 성공의 4단계",
  "brands.process.step1": "무료 상담",
  "brands.process.step1_desc": "브랜드의 현재 상황과 중국 진출 목표를 듣습니다",
  "brands.process.step2": "전략 수립",
  "brands.process.step2_desc": "샤오홍슈 맞춤 콘텐츠 전략과 라이브 로드맵을 설계합니다",
  "brands.process.step3": "실행 & 운영",
  "brands.process.step3_desc": "콘텐츠 제작, 라이브 진행, 스토어 운영을 풀매니지먼트합니다",
  "brands.process.step4": "성과 분석",
  "brands.process.step4_desc": "데이터를 기반으로 지속적인 최적화와 성장을 도모합니다",

  "brands.cta.title_line1": "브랜드의 샤오홍슈 성공,",
  "brands.cta.title_line2": "지금 시작하세요",
  "brands.cta.desc": "상담은 언제나 무료입니다. 브랜드에 딱 맞는 샤오홍슈 전략을 함께 설계하겠습니다.",
  "brands.cta.button": "무료 상담 신청",
}
